import {getWebsiteId} from "@/helpers/getWebsiteId";
import {getShopHostname} from "@/helpers/getShopHostname";
import {getWebsiteUrl} from "@/helpers/getWebsiteUrl";
import {getEmailSupport} from "./helpers/getEmailSupport";
import {isDevEnvironment} from "@/helpers/isDevEnvironment";
import {getAppUrl} from "@/helpers/getAppUrl";
import {extractDomain} from "@/helpers/extractDomain";
import {checkIsWhiteLabelApp} from "@/helpers/checkIsWhiteLabelApp";

export const config = {
  isDev: isDevEnvironment,
  isNativeApp: navigator?.userAgent?.indexOf("median") > -1 || window.median !== undefined,
  isWhiteLabelApp: checkIsWhiteLabelApp(),
  websiteId: getWebsiteId(),
  websiteUrl: getWebsiteUrl(),
  websiteSupportEmail: getEmailSupport(getWebsiteId()),
  appUrl: getAppUrl(),
  domain: extractDomain(getAppUrl()),
  shopHostname: getShopHostname(),
  googlePlayStoreUrl: {
    forth: "https://play.google.com/store/apps/details?id=com.forthlife",
    edge: "https://play.google.com/store/apps/details?id=com.forthedge",
  },
  appleStoreUrl: {
    forth: "https://apps.apple.com/gb/app/forth-life/id1463063574",
    edge: "https://apps.apple.com/gb/app/forth-edge/id1468480957",
  },
};

globalThis.window.config = config;
